import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_INVITATION = "access-control-service/invitations";

const RESOURCES = {
	LIST_ALL_INVITATIONS_PAGINATED: (page, searchText, organizationId, orderBy, disabled) => {
		const params = new URLSearchParams({
			page,
			limit: 8,
			searchBy: searchText,
			orderBy: orderBy?.collumnTitle || "",
			orderDirection: orderBy?.orderDirection || "",
		});

		if (disabled !== null && disabled !== undefined) {
			params.append("disabled", disabled);
		}

		return `${BASE_INVITATION}/organizations/${organizationId}/paginated?${params.toString()}`;
	},
	GET_BY_ID: (id) => `${BASE_INVITATION}/${id}`,
	DELETE_INVITATION: (id) => `${BASE_INVITATION}/${id}`,
};

class InvitationService {
	static async listInvitationsPaginated(
		page,
		searchText,
		organizationId,
		orderBy,
		cancelToken,
		disabled = null,
	) {
		try {
			return await axios.get(
				RESOURCES.LIST_ALL_INVITATIONS_PAGINATED(
					page,
					searchText,
					organizationId,
					orderBy,
					disabled
				),
				{
					signal: cancelToken,
					headers: {
						"Cache-Control": "no-cache",
					},
				}
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar convites",
			});
			return error.response;
		}
	}

	static async getInvitation(id) {
		try {
			const response = await axios.get(RESOURCES.GET_BY_ID(id));
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao obter convite",
			});
			return error.response;
		}
	}

	static async getInvitationByToken(token) {
		try {
			const response = await axios.get(`${BASE_INVITATION}/token/${token}`);
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao obter convite",
			});
			return error.response;
		}
	}

	static async createInvitation(payload) {
		try {
			const response = await axios.post(BASE_INVITATION, payload);
			ResponseAlerts({
				response: response,
				successMessage: "Convite cadastrado com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao cadastrar convite",
			});
			return error.response;
		}
	}

	static async deleteInvitation(id) {
		try {
			const response = await axios.delete(RESOURCES.DELETE_INVITATION(id));
			ResponseAlerts({
				response: response,
				successMessage: "Convite excluído com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao excluir convite",
			});
			return error.response;
		}
	}

	static async updateInvitation(id, payload) {
		return await axios
			.put(BASE_INVITATION + "/" + id, payload)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Convite atualizado com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: "Erro ao atualizar convite",
				});
				return error.response;
			});
	}
}

export default InvitationService;
